<template>
  <!-- <v-sheet class="`justify-center`" max-width="1200"> -->
  <v-container>
    <v-sheet class="page-container mb-12">
      <v-sheet>
        <v-row class="d-flex mb-6">
          <div class="pa-2">
            <v-avatar color="grey" size="178" tile>
              <v-img :src="commonUtils.getImageUrl(album.data.cover_uuid)"></v-img>
            </v-avatar>
          </div>

          <div class="album-detail textcolor--text">
            <v-row class="align-center mb-2">
              <div class="album-name">{{ albumName(album) }}</div>
              <v-btn
                depressed
                rounded
                color="white"
                flat
                class="textcolor--text"
                style="border-width: 1 !important; border-color: #e3e3e3 !important; border-style: solid !important; margin-right: 10px;"
                @click="editAlbum"
                height="26"
                width="40"
              >{{$t('album.edit')}}</v-btn>
              <v-btn
                depressed
                rounded
                flat
                color="errorlight"
                class="errorstrong--text"
                @click="deleteAlbum"
                height="26"

              >{{$t('album.delete')}}</v-btn>
            </v-row>
            <v-row class="author-row textcolor6--text">
              <div>{{$t('album_form.publisher')}}:</div>
              <div class="ml-2">{{ albumPublisher }}</div>
              <div class="ml-2">{{$t('album_form.editor')}}:</div>
              <div class="ml-2">{{ albumEditor }}</div>
            </v-row>

            <v-row class="album-detail-1-item align-center">
              <div>{{sheetNumberTitle}}</div>
              <div
                class="primary white--text language-label ml-2"
                v-for="(lan, index) in languageList"
                :key="index"
              >{{lan}}</div>
            </v-row>
            <v-row class="d-flex align-center mt-2" style="max-width: 400px" v-if="sheets.length > 0 && album.scope == 'public'">
              <div>{{$t('album.tag')}}:</div>
              <div
                v-for="tag in albumTags"
                class="black white--text px-2 mx-1 tag"
                :key="tag"
              >{{tag}}</div>
              <div depressed flat height="20">
                <v-menu v-model="menu" :close-on-content-click="false" offset-x>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="white add-tag-btn ml-3"
                      depressed
                      @click="clickAddTag"
                      style="border-width: 1 !important; border-color: #e3e3e3 !important; border-style: solid !important; margin-right: 10px;"
                      v-on="on"
                      width="96"
                      height="26"
                    >
                      <div class="mx-2">+ {{$t('album.add_tag')}}</div>
                    </v-btn>
                  </template>

                  <v-card width="477">
                    <!-- :items="allTags" -->
                    <!-- MGroupSelectorPanel -->
                    <m-group-selector-panel
                      v-model="selectedTag"
                      v-on:onClose="menu = false"
                      v-on:onSeleteChange="onSeleteChange"
                      :isEqual=" (v1, v2) => v1.name == v2.name"
                      :items="allTags"
                      :title="$t('album.chooseAddedTag')"
                      :emptyPlaceHolder="$t('album.tag_empty_notation')"
                    ></m-group-selector-panel>
                    <!-- <m-selector-panel
                      v-model="selectedTag"
                      v-on:onClose="menu = false"
                      v-on:onSeleteChange="onSeleteChange"
                      :isEqual=" (v1, v2) => v1.name == v2.name"
                      :items="[]"
                      :groupItems="allTags"
                      :title="$t('album.chooseAddedTag')"
                      :emptyPlaceHolder="$t('album.tag_empty_notation')"
                    ></m-selector-panel>-->
                  </v-card>
                </v-menu>
              </div>
            </v-row>

            <v-row class="album-detail-1-item">
              <div>{{ albumDescription }}</div>
            </v-row>

            <v-row class="album-detail-1-item align-center">
              <div class="mr-2">{{$t('album.current_share_scope')}}:</div>
              <div>{{ commonUtils.getShareScope(album.scope, this)}}</div>
              <div class="ml-2" v-for="(share, index) in shares" :key="index">{{ share }}</div>
            </v-row>
          </div>

          <div class="d-flex flex-column justify-end pa-2 ml-auto album-detail-end">
            <v-row class="justify-end align-start">
              <div>{{ $t('album.create_at') + ' ' + formatedTime(album.ctime) }}</div>
            </v-row>
            <v-row class="justify-end align-start">
              <div>{{ $t('album.album_state') }}:</div>
              <div>{{ releaseState}}</div>
            </v-row>
            <v-row class="justify-end align-start" v-if="album.scope == 'public'">
              <div>{{ $t('album.sheet_state.review_state') }}:</div>
              <div>{{ reviewState }}</div>
              <div
                class="underline ml-2 errorstrong--text"
                @click="gotoReviewDetail">{{ $t('album.check') }}</div>
            </v-row>
            <v-row class="justify-end">
              <div
                @click="changeAlbumReleaseState"
                class="change-state"
              >{{$t('album.change_state')}}</div>
            </v-row>

            <v-row class="align-end justify-end upload-btn">
              <v-btn
                depressed
                rounded
                class="primary"
                @click="uploadSheet"
              >{{$t('albums.table.create_sheet')}}</v-btn>
            </v-row>
          </div>
        </v-row>
      </v-sheet>
      <v-simple-table fixed-header v-if="!loading">
        <template v-slot:default>
          <thead>
            <tr class>
              <th class="text-left mbackgroundcolor">{{$t('album.sheet_name')}}</th>
              <th class="text-left mbackgroundcolor">{{$t('album.sheet_state.title')}}</th>
              <th class="text-left mbackgroundcolor">{{$t('albums.table.ctime')}}</th>
              <th class="text-left mbackgroundcolor">{{$t('albums.table.score_count')}}</th>
              <th class="text-left mbackgroundcolor">{{$t('albums.table.operation')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(sheet, index) in sheets"
              :key="sheet.uuid"
              :class="{mbackgroundcolor: index%2 !== 0}"
            >
              <td>
                <v-row class="pa-4">
                    <div class="name" @click="selectSheet(sheet)">{{ getSheetName(sheet) }}</div>
                </v-row>
              </td>
              <td>{{ getReviewState(sheet) }}</td>
              <td>{{ formatedTime(sheet.ctime) }}</td>
              <td>{{ sheet.score_count }}</td>
              <td>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      rounded
                      depressed
                      color="transparent"
                      v-on="on"
                      height="26"
                      class="edit-btn move-album-btn"
                      style="border-width: 1 !important; border-color: #e3e3e3 !important; border-style: solid !important; margin-right: 10px;"
                    >{{$t('album.move')}}</v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(album, index) in albums"
                      :key="index"
                      @click="moveSheet(album, sheet)"
                    >
                      <v-list-item-title>{{ albumName(album) }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div class="d-flex justify-center pa-5 form-title" v-if="sheets.length == 0 && !loading">
        <div>{{$t('album.text.empty_notation')}}</div>
      </div>

      <div class="d-flex flex-column justify-center" style="height: 300px" v-if="loading">
        <div class="d-flex justify-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary mt-12"
            indeterminate
          ></v-progress-circular>
        </div>
      </div>

    </v-sheet>

  </v-container>
  <!-- </v-sheet> -->
</template>

<script>
import MSelectorPanel from "../components/common/MSelectorPanel";
import MGroupSelectorPanel from "../components/common/MGroupSelectorPanel";

export default {
  name: "AlbumDetail",
  components: {
    mSelectorPanel: MSelectorPanel,
    mGroupSelectorPanel: MGroupSelectorPanel
  },
  data: function() {
    return {
      loading: false,
      selectedTag: [],
      menu: false,
      album: null,
      //   allTags: [],
      allTags: {},
      shares: [],
      add_logo: require("../assets/img/add_icon.svg"),
      sheets: [], // data: { name, subtitle, description } ctime , mtime, instruments
      albums: []
    };
  },
  mounted() {
    console.warn('albumdetail mounted');
    this.$store.commit("setCurrentScore", { score: null });
    this.$store.commit("setCurrentSheet", { sheet: null });
    this.album = this.$store.getters.currentAlbum;
    if (this.album.scope === "team" || this.album.scope === "organization") {
      this.commonUtils
        .getSharesByUuid(
          this,
          this.album.uuid,
          this.album.scope,
          "album",
          "name"
        )
        .then(
          function(response) {
            console.log("getSharesByUuid", response);
            this.shares = this.shares.concat(response);
          }.bind(this)
        );
    }

    if (this.album.uuid) {
      this.commonUtils
        .getAlbumAvailableTags(this.album.uuid, this)
        .then(response => {
          console.log("all tag", response);
          this.allTags = response;
          //   for (const key in response) {
          //     if (response.hasOwnProperty(key)) {
          //       const element = response[key];
          //       if (!element || !element.children) {
          //           break;
          //       }
          //       element.children.forEach(tag => {
          //         if (this.$i18n.locale == "zh") {
          //           this.allTags.push({
          //             text: tag.name,
          //             value: tag
          //           });
          //         } else {
          //           this.allTags.push({
          //             text: tag.name,
          //             value: tag
          //           });
          //         }
          //       });
          //     }
          //   }
        });
    }

    this.commonUtils.getTagsByInstance(this, this.album.uuid, "data").then(
      function(response) {
        if (response.length > 0) {
          this.selectedTag.push(...response);
        }
      }.bind(this)
    );

    console.log("uuid", this.album.uuid);
    this.loading = true;
    this.commonUtils.getSheetsOfAlbum(this.album.uuid, this).then(
      function(response) {

        console.log("get sheets in album", response, this.sheets);

        this.sheets = this.sheets.concat(response);

        this.loading = false;
        console.log("getSheetsOfAlbum.sheet info", response.sheet_info);
      }.bind(this)
    );
    this.commonUtils
      .getAlbumsByUuid(this.$store.getters.userUuid, this)
      .then(response => {
        console.log("getAlbumsByUuid", response);
        this.albums = this.albums.concat(
          response.filter(album => {
            return album.uuid !== this.album.uuid;
          })
        );
      });
  },
  computed: {
    languageList: function() {
      if (!this.album || !this.album.data) {
        return [];
      }
      let lanList = this.commonUtils.getLanguageFromData(this.album.data);
    //   debugger


      lanList = lanList.map(lan => {
        return this.commonUtils.getLanguageText(
          this,
          lan,
          this.album.data.default_lang
        );
      });
      lanList = [...new Set(lanList)];
      return lanList;
    },
    albumTags: function() {
      return this.selectedTag.map(tag => {
        if (this.$i18n.locale == "zh") {
          return tag.name;
        } else {
          return tag.name_en;
        }
      });
    },
    sheetNumberTitle: function() {
      if ((this.$i18n.locale == "zh")) {
        return `共 ${this.sheets.length} 首乐曲`;
      }
      return `Music pieces: ${this.sheets.length}`;
      return this.sheets.length;
    },
    isOnline: function() {
      //   if (this.album.release_status == 'online') {
      //     if (this.sheets.length == 0) {
      //       return false;
      //     } else {
      //       return true;
      //     }
      //   } else {
      //       }
      return this.album.release_status == "online";
    },
    releaseState: function() {
        return this.commonUtils.getAlbumReleaseStatus(this, this.album.release_status)
    },
    reviewState: function() {
        return this.commonUtils.getReviewStatus(this, this.album.review_status);
    },

    albumPublisher: function() {
        if (!this.album) return '';
        const currentLan = this.$i18n.locale;
        if (this.album.data[`publisher_${currentLan}`]) {
            return this.album.data[`editor_${currentLan}`]
        } else {
            return this.album.data.publisher_base;
        };
    },
    albumEditor: function() {
        if (!this.album) return '';
        const currentLan = this.$i18n.locale;
        if (this.album.data[`editor_${currentLan}`]) {
            return this.album.data[`editor_${currentLan}`]
        } else {
            return this.album.data.editor_base;
        };
    },
    albumDescription: function() {
        if (!this.album) return ''
        const currentLan = this.$i18n.locale;
        if (this.album.data[`description_${currentLan}`]) {
            return this.album.data[`description_${currentLan}`]
        } else {
            return this.album.data.description_base;
        };
    }

  },
  created() {
    //   album.scope == organization public private
    console.log("album detail created", this.album);
    return;
  },
  methods: {
    getSheetName: function(sheet) {
        if (!sheet) return '';
        return this.commonUtils.getDataWithLanguage(this, sheet, 'name');
    },
    albumName: function(album) {
      if (!this.album) return '';
      return this.commonUtils.getDataWithLanguage(this, album, 'name');
    },
    onSeleteChange: async function(tagChange) {
      const albumUuid = this.album.uuid;
      if (tagChange.isAdd) {
        const result = await this.commonUtils.addTag(
          this,
          albumUuid,
          tagChange.value.uuid
        );
      } else {
        const result = await this.commonUtils.deleteTag(
          this,
          albumUuid,
          tagChange.value.uuid
        );
      }
    },
    clickAddTag: function() {
      console.log("clickAddTag");
    },
    formatedTime: function(timeString) {
      return this.commonUtils.convertTimeFormat(timeString);
    },
    editAlbum: function() {
      //   this.$router.push({ name: "album_info_edit" });
      this.$store.commit("setRouteBackTo", {route_back_to: 'album_detail'});
      this.$router.push({ name: "album_form" });
      // this.commonUtils.
    },
    deleteAlbum: async function() {
      this.$confirm(
        this.$t("album.text.comfire_delete_album"),
        this.$t("global.text.dialog_notice"),
        {
          confirmButtonText: this.$t("global.text.btn_confirm"),
          cancelButtonText: this.$t("global.text.btn_cancel")
        }
      )
        .then(async () => {
          if (this.sheets.length > 0) {
            this.$message({
              message: this.$t("album.text.delete_need_sheets_empty"),
              type: "error"
            });
          } else {
            await this.commonUtils.deleteAlbumByUuid(this.album.uuid, this);
            this.$router.push({ name: "albums" });
          }
        })
        .catch(() => {});
    },
    gotoSheet: function() {
      this.$router.push({ name: "sheet_detail" });
      //   this.$router.push({path: '/album_detail/sheet_detail'});
      //   this.$router.go({name: 'sheet_detail'});
    },
    getReviewState: function(sheet) {

        return this.commonUtils.getAlbumReleaseStatus(this, sheet.release_status, sheet.review_status)
    },
    selectSheet: function(sheet) {
      this.commonUtils.toSheetDetail(this, sheet);
    },
    uploadSheet: function() {
      this.$store.commit("setCurrentScore", { score: null });
      this.$store.commit("setCurrentSheet", { sheet: null });
      this.$store.commit("setRouteBackTo", {route_back_to: 'album_detail'});
      this.$router.push({ name: "create_sheet", params: { is_create_sheet: true }});
    },
    reloadSheet: function() {
      this.commonUtils.getSheetsOfAlbum(this.album.uuid, this).then(
        function(response) {
          this.sheets.splice(0, this.sheets.length);
          console.log('this.sheets', this.sheets);
          this.sheets = this.sheets.concat(response);

          console.log(this.sheets);
        }.bind(this)
      );
    },
    createSheet: function() {
      this.commonUtils.toSheetForm(this);
    },
    moveSheet: function(album, sheet) {
      // TODO:
      console.log(album, sheet);
      //   moveSheet: async function (album_uuid, sheet_uuid, _this) {
      //   this.commonUtils.moveSheet()
      const album_uuid = album.uuid;
      if (sheet.release_status === "online" && album.scope === "public") {
        this.$confirm(
          this.$t("album.sheet.text.confirm_move_sheet"),
          this.$t("global.text.dialog_notice"),
          {
            confirmButtonText: this.$t("global.text.btn_confirm"),
            cancelButtonText: this.$t("global.text.btn_cancel")
          }
        )
          .then(() => {
            this.commonUtils
              .moveSheet(album_uuid, sheet.uuid, this)
              .then(response => {
                if (response) {
                  //   this.$emit("reload-sheet");
                  this.reloadSheet();
                }
              });
          })
          .catch(() => {});
      } else {
        this.commonUtils
          .moveSheet(album_uuid, sheet.uuid, this)
          .then(response => {
            console.log(response);
            if (response) {
              //   this.$emit("reload-sheet");
              this.reloadSheet();
            }
          });
      }
    },
    deleteSheet: function(sheet_uuid) {
      for (let i = 0; i < this.sheets.length; i++) {
        if (this.sheets[i].uuid === sheet_uuid) {
          this.sheets.splice(i, 1);
        }
      }
    },
    async changeAlbumReleaseState() {
      if (this.isOnline) {
          this.$confirm(
          this.$t("album.sheet.text.offline_sheet_confirm"),
          this.$t("global.text.dialog_notice"),
          {
            confirmButtonText: this.$t("global.text.btn_confirm"),
            cancelButtonText: this.$t("global.text.btn_cancel")
          }
        ).then(async () => {
            await this.offlineAlbum();
        });
      } else {
        await this.releaseAlbum();


      }
    },
    releaseAlbum: function() {
      if (this.album.scope === "public" && this.album.review_status != 'pass') {
        this.$confirm(
          this.$t("album.text.confirm_release_album"),
          this.$t("global.text.dialog_notice"),
          {
            confirmButtonText: this.$t("global.text.btn_confirm"),
            cancelButtonText: this.$t("global.text.btn_cancel")
          }
        )
          .then(() => {
            this.commonUtils
              .releaseAlbum(this.album.uuid, this)
              .then(response => {
                if ((response && response.success) || response.album_released) {
                  this.album.release_status = "online";
                }

                if (!response.success && response.msg == 'album.msg.release_faile_is_public') {
                    this.album.review_status = 'reviewing';
                    this.album.release_status = "offline";
                }
              });
          })
          .catch(() => {});
      } else {
        this.commonUtils.releaseAlbum(this.album.uuid, this).then(response => {
          if ((response && response.success) || response.album_released) {
            this.album.release_status = "online";
          }
        });
      }
    },
    gotoReviewDetail: function() {
      this.$router.push({
        name: "album_review_detail"
      });
    },
    offlineAlbum: function() {
      this.commonUtils.offlineAlbum(this.album.uuid, this).then(response => {
        if (response && response.success) {
          this.album.release_status = "offline";
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../assets/css/font.css";
@import "../assets/css/common.css";

.name {
  cursor: pointer;
  border-width: 0;
  height: 18px;
  border-bottom-width: 1px;
  margin-right: 4px;
  border-style: solid;
  border-color: #333333;
}

.page-container {
  padding: 30px;
}

.add-tag {
  margin-left: 10px;
  border-width: 1px;
  border-color: #333333;
  border-style: solid;
  border-radius: 4px;
  padding-left: 5px;
}

.album-detail {
  margin-left: 43px;
}
.album-detail-1-item {
  margin-top: 8px;
}

.album-detail-end {
  height: 174px;
}

.add-tag-btn {
  height: 20px !important;
  border-width: 1px !important;
  border-color: #333333 !important;
  color: #333333;
  padding-left: 35px;
  padding-right: 15px;
  border-style: solid !important;
  border-radius: 4px !important;
  font-size: 12px;
  /* font-family: SHRegular; */
  font-weight: normal;
}

v-btn .edit-btn {
  border-width: 1 !important;
  border-color: #e3e3e3 !important;
  border-style: solid !important;
  margin-right: 10px;
}

.change-state {
  border-width: 0;
  border-bottom-width: 1px;
  padding-bottom: 2px;
  height: 18px;
  border-style: solid;
  border-color: #666666;
  color: #666666;
  cursor: pointer;
}



.author-row {
  margin-bottom: 20px;
}

div {
  font-size: 14px;
}
.album-name {
  /* font-family: SHBold; */
  font-weight: bold;
  padding-right: 20px;
  font-size: 20px;
}

.upload-btn {
  bottom: 0;
}
.move-album-btn {
  /* font-family: "SHRegular"; */
  font-weight: normal;
}

.table-title {
  /* font-family: "SHBold"; */
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 12px;
}
.table {
  border-color: "#ff0000";
}

.tag {
  border-radius: 4px;
  font-size: 12px;
}

.language-label {
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 2px;
  padding-bottom: 1px;
  border-radius: 4px;
  font-size: 12px
}

.underline {
  text-decoration: underline;
  cursor: pointer;
}

.review-container {
    border-radius: 2px;
    padding-left: 4px;
    padding-right: 4px;
    margin-left: 4px;
}
</style>
